import { render, staticRenderFns } from "./matrixChangeMonitoring.vue?vue&type=template&id=b8146ec2&scoped=true"
import script from "./matrixChangeMonitoring.vue?vue&type=script&lang=js"
export * from "./matrixChangeMonitoring.vue?vue&type=script&lang=js"
import style0 from "./matrixChangeMonitoring.vue?vue&type=style&index=0&id=b8146ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8146ec2",
  null
  
)

export default component.exports